import {faIconCreator} from './fa-icon-creator';

export {getFileIcon} from './get-icon';
export {NotificationIcon} from './notification-icon';

export {ButtonIcon} from './button-icon';

export {LeadStatusIcon} from './lead-status-icon';
export type {Status} from './lead-status-icon';

export {MessengerColoredIcon} from './messenger-colored-icon';
export {InstagramColoredIcon} from './instagram-colored-icon';
export {FacebookColoredIcon} from './facebook-colored-icon';

export {EmailSequenceIcon} from './email-sequence-icon';

// 2025 navigation icons
export {NavIconAdministrationIcon} from './navigation/nav-icon-administration';
export {NavIconAutomationIcon} from './navigation/nav-icon-automation';
export {NavIconChatIcon} from './navigation/nav-icon-chat';
export {NavIconChevronLeftIcon} from './navigation/nav-icon-chevron-left';
export {NavIconChevronRightIcon} from './navigation/nav-icon-chevron-right';
export {NavIconConnectionsIcon} from './navigation/nav-icon-connections';
export {NavIconDashboardIcon} from './navigation/nav-icon-dashboard';
export {NavIconDataIcon} from './navigation/nav-icon-data';
export {NavIconEmailIcon} from './navigation/nav-icon-email';
export {NavIconEngagementIcon} from './navigation/nav-icon-engagement';
export {NavIconMarketingIcon} from './navigation/nav-icon-marketing';
export {NavIconOrganizationIcon} from './navigation/nav-icon-organization';
export {NavIconProspectorIcon} from './navigation/nav-icon-prospector';
export {NavIconQuotasIcon} from './navigation/nav-icon-quotas';
export {NavIconSalesIcon} from './navigation/nav-icon-sales';
export {NavIconSchedulerIcon} from './navigation/nav-icon-scheduler';
export {NavIconSettingsIcon} from './navigation/nav-icon-settings';
export {NavIconSettingsWrenchIcon} from './navigation/nav-icon-settings-wrench';
export {NavIconYourSettingsIcon} from './navigation/nav-icon-your-settings';
export {NavIconWebsiteIcon} from './navigation/nav-icon-website';
export {NavIconLogoutIcon} from './navigation/nav-icon-logout';

// SVG
export {AcceptedIcon} from './svg/accepted-icon';
export {AccountChildOverlayIcon} from './svg/account-child-overlay-icon';
export {AccountIcon} from './svg/account-icon';
export {AccountParentCircleIcon} from './svg/account-parent-circle-icon';
export {AccountParentIcon} from './svg/account-parent-icon';
export {AccountsCircleIcon} from './svg/accounts-circle-icon';
export {ActivitiesCircleIcon} from './svg/activities-circle-icon';
export {ActivityEmptyStateIcon} from './svg/activity-empty-state-icon';
export {ActivityErrorStateIcon} from './svg/activity-error-state-icon';
export {ActivityIcon} from './svg/activity-icon';
export {ActivityLogRegularAiIcon} from './svg/activity-log-regular-ai-icon';
export {ActivityMinimizeIcon} from './svg/activity-minimize-icon';
export {AddIcon} from './svg/add-icon';
export {AddPersonRegularIcon} from './svg/add-person-regular-icon';
export {AddReactionIcon} from './svg/add-reaction-icon';
export {AddressCardIcon} from './svg/address-card-icon';
export {AdminDigestRegularAiIcon} from './svg/admin-digest-regular-ai-icon';
export {AdminLockIcon} from './svg/admin-lock-icon';
export {AircallIcon} from './svg/aircall-icon';
export {AircallRegularAiIcon} from './svg/aircall-regular-ai-icon';
export {AiSparkleNewIcon} from './svg/ai-sparkle-new-icon';
export {AlarmClockIcon} from './svg/alarm-clock-icon';
export {AlignCenterIcon} from './svg/align-center-icon';
export {AlignLeftIcon} from './svg/align-left-icon';
export {AlignRightIcon} from './svg/align-right-icon';
export {ArchiveIcon} from './svg/archive-icon';
export {ArchiveRegularIcon} from './svg/archive-regular-icon';
export {ArrowDownIcon} from './svg/arrow-down-icon';
export {ArrowDownThinIcon} from './svg/arrow-down-thin-icon';
export {ArrowDownUpRegularIcon} from './svg/arrow-down-up-regular-icon';
export {ArrowLeftRightRegularIcon} from './svg/arrow-left-right-regular-icon';
export {ArrowRightIcon} from './svg/arrow-right-icon';
export {ArrowRightThinIcon} from './svg/arrow-right-thin-icon';
export {ArrowsAscIcon} from './svg/arrows-asc-icon';
export {ArrowsDescIcon} from './svg/arrows-desc-icon';
export {ArrowsMergeRegularIcon} from './svg/arrows-merge-regular-icon';
export {ArrowsWidthRegularIcon} from './svg/arrows-width-regular-icon';
export {ArrowUpDownIcon} from './svg/arrow-up-down-icon';
export {ArrowUpIcon} from './svg/arrow-up-icon';
export {AttendeeCircleIcon} from './svg/attendee-circle-icon';
export {AttendeeSquareIcon} from './svg/attendee-square-icon';
export {AudienceIcon} from './svg/audience-icon';
export {AutoDistributionBoltIcon} from './svg/auto-distribution-bolt-icon';
export {AvatarGreenIcon} from './svg/avatar-green-icon';
export {AvatarPurpleIcon} from './svg/avatar-purple-icon';
export {AvatarTealIcon} from './svg/avatar-teal-icon';
export {AvatarYellowIcon} from './svg/avatar-yellow-icon';
export {BarChartRegularIcon} from './svg/bar-chart-regular-icon';
export {BellRegularIcon} from './svg/bell-regular-icon';
export {BinocularsRegularAiIcon} from './svg/binoculars-regular-ai-icon';
export {BoardRegularIcon} from './svg/board-regular-icon';
export {BoltRegularIcon} from './svg/bolt-regular-icon';
export {BookIcon} from './svg/book-icon';
export {BookRegularIcon} from './svg/book-regular-icon';
export {BoxesRegularIcon} from './svg/boxes-regular-icon';
export {BoxRegularIcon} from './svg/box-regular-icon';
export {BoxRegularReportIcon} from './svg/box-regular-report-icon';
export {BracketsRegularIcon} from './svg/brackets-regular-icon';
export {BranchRegularIcon} from './svg/branch-regular-icon';
export {BriefcaseRegularIcon} from './svg/briefcase-regular-icon';
export {BroadcastIcon} from './svg/broadcast-icon';
export {BrowserIcon} from './svg/browser-icon';
export {BulletListRegularIcon} from './svg/bullet-list-regular-icon';
export {BusinessCardRegularIcon} from './svg/business-card-regular-icon';
export {CalendarFollowUpIcon} from './svg/calendar-follow-up-icon';
export {CalendarIcon} from './svg/calendar-icon';
export {CalendarPenIcon} from './svg/calendar-pen-icon';
export {CalendarPenRegularReportIcon} from './svg/calendar-pen-regular-report-icon';
export {CalendarPreviousIcon} from './svg/calendar-previous-icon';
export {CalendarRegularPenIcon} from './svg/calendar-regular-pen-icon';
export {CalendarRegularPlaneIcon} from './svg/calendar-regular-plane-icon';
export {CalendarRegularReportIcon} from './svg/calendar-regular-report-icon';
export {CalendarSquareRegularActivityIcon} from './svg/calendar-square-regular-activity-icon';
export {CalendarSquareRegularAgendaIcon} from './svg/calendar-square-regular-agenda-icon';
export {CalendarSquareRegularCheckIcon} from './svg/calendar-square-regular-check-icon';
export {CalendarSquareRegularEventTypeIcon} from './svg/calendar-square-regular-event-type-icon';
export {CalendarSquareRegularTypeIcon} from './svg/calendar-square-regular-type-icon';
export {CalendarToNutshellIcon} from './svg/calendar-to-nutshell-icon';
export {CalendarXIcon} from './svg/calendar-x-icon';
export {CallrailIcon} from './svg/callrail-icon';
export {CallrailRegularAiIcon} from './svg/callrail-regular-ai-icon';
export {CampaignIcon} from './svg/campaign-icon';
export {CancelCircleRegularIcon} from './svg/cancel-circle-regular-icon';
export {CancelIcon} from './svg/cancel-icon';
export {CancelRegularReportIcon} from './svg/cancel-regular-report-icon';
export {CardIcon} from './svg/card-icon';
export {CaretSolidDownIcon} from './svg/caret-solid-down-icon';
export {ChartLineConnectedRegularReportIcon} from './svg/chart-line-connected-regular-report-icon';
export {ChartLineRegularIcon} from './svg/chart-line-regular-icon';
export {ChartLineRegularReportIcon} from './svg/chart-line-regular-report-icon';
export {ChartLineUpRegularIcon} from './svg/chart-line-up-regular-icon';
export {ChatbotIcon} from './svg/chatbot-icon';
export {ChatbotRegularAiIcon} from './svg/chatbot-regular-ai-icon';
export {ChatbotRegularIcon} from './svg/chatbot-regular-icon';
export {ChatbotRegularReportIcon} from './svg/chatbot-regular-report-icon';
export {ChatBubbleCheckmarkRegularIcon} from './svg/chat-bubble-checkmark-regular-icon';
export {ChatBubbleDotRegularIcon} from './svg/chat-bubble-dot-regular-icon';
export {ChatBubbleDoubleRegularIcon} from './svg/chat-bubble-double-regular-icon';
export {ChatBubbleQuestionRegularIcon} from './svg/chat-bubble-question-regular-icon';
export {ChatBubbleRegularIcon} from './svg/chat-bubble-regular-icon';
export {ChatBubbleSlashRegularIcon} from './svg/chat-bubble-slash-regular-icon';
export {ChatEllipsisSolidIcon} from './svg/chat-ellipsis-solid-icon';
export {ChatIcon} from './svg/chat-icon';
export {ChatMessageIcon} from './svg/chat-message-icon';
export {ChatRegularIcon} from './svg/chat-regular-icon';
export {ChatRegularOptionsIcon} from './svg/chat-regular-options-icon';
export {ChatRegularReportIcon} from './svg/chat-regular-report-icon';
export {CheckboxIcon} from './svg/checkbox-icon';
export {CheckCircleRegularIcon} from './svg/check-circle-regular-icon';
export {CheckCircleSolidIcon} from './svg/check-circle-solid-icon';
export {CheckmarkIcon} from './svg/checkmark-icon';
export {CheckRegularIcon} from './svg/check-regular-icon';
export {CheckRegularReportIcon} from './svg/check-regular-report-icon';
export {ChevronDown} from './svg/chevron-down-icon';
export {ChevronLightRegularDownIcon} from './svg/chevron-light-regular-down-icon';
export {ChevronLightRegularLeft} from './svg/chevron-light-regular-left-icon';
export {ChevronLightRegularRight} from './svg/chevron-light-regular-right-icon';
export {ChevronRegularRightLeadReportIcon} from './svg/chevron-regular-right-lead-report-icon';
export {CircleDollarRegularIcon} from './svg/circle-dollar-regular-icon';
export {CircleExSolidIcon} from './svg/circle-ex-solid-icon';
export {CircleMinusIcon} from './svg/circle-minus-icon';
export {CirclePersonIcon} from './svg/circle-person-icon';
export {CirclePlusRegularIcon} from './svg/circle-plus-regular-icon';
export {CircleRegularIcon} from './svg/circle-regular-icon';
export {CircleWarningIcon} from './svg/circle-warning-icon';
export {ClaudeOutlineAIIcon} from './svg/claude-outline-ai-icon';
export {ClipboardChecklistIcon} from './svg/clipboard-checklist-icon';
export {ClockArrowRegularIcon} from './svg/clock-arrow-regular-icon';
export {ClockRegularIcon} from './svg/clock-regular-icon';
export {CloneIcon} from './svg/clone-icon';
export {CloseHeavyRegularIcon} from './svg/close-heavy-regular-icon';
export {CloseIcon} from './svg/close-icon';
export {CloseLightRegularIcon} from './svg/close-light-regular-icon';
export {CloudUploadRegularIcon} from './svg/cloud-upload-regular-icon';
export {CodeIcon} from './svg/code-icon';
export {CogIcon} from './svg/cog-icon';
export {CogRegularIcon} from './svg/cog-regular-icon';
export {CogRegularReportIcon} from './svg/cog-regular-report-icon';
export {CollapseIcon} from './svg/collapse-icon';
export {ColumnPickerIcon} from './svg/column-picker-icon';
export {ComingSoonIcon} from './svg/coming-soon-icon';
export {CommentIcon} from './svg/comment-icon';
export {CommentPencilRegularIcon} from './svg/comment-pencil-regular-icon';
export {CommentSmileRegularIcon} from './svg/comment-smile-regular-icon';
export {CompanyContactIcon} from './svg/company-contact-icon';
export {CompanyIcon} from './svg/company-icon';
export {CompanyRegularIcon} from './svg/company-regular-icon';
export {CompanySearchRegularAiIcon} from './svg/company-search-regular-ai-icon';
export {CompanyTypeIcon} from './svg/company-type-icon';
export {CompanyWarningRegularIcon} from './svg/company-warning-regular-icon';
export {CompassIcon} from './svg/compass-icon';
export {CompetitorRegularAiIcon} from './svg/competitor-regular-ai-icon';
export {CompetitorRegularIcon} from './svg/competitor-regular-icon';
export {CompleteRegularIcon} from './svg/complete-regular-icon';
export {ComputerMobileRegularIcon} from './svg/computer-mobile-regular-icon';
export {ConfirmIcon} from './svg/confirm-icon';
export {ConnectionRegularIcon} from './svg/connection-regular-icon';
export {ConnectedFormsIcon} from './svg/connected-forms-icon';
export {ConstantContactIcon} from './svg/constant-contact-icon';
export {ContactAssigneeIcon} from './svg/contact-assignee-icon';
export {ContactIcon} from './svg/contact-icon';
export {ContactsBookRegularIcon} from './svg/contacts-book-regular-icon';
export {ContactsCircleIcon} from './svg/contacts-circle-icon';
export {CopyIcon} from './svg/copy-icon';
export {CopyRegularIcon} from './svg/copy-regular-icon';
export {CreditCardRegularIcon} from './svg/credit-card-regular-icon';
export {CsvImportIcon} from './svg/csv-import-icon';
export {CtcKeypadIcon} from './svg/ctc-keypad-icon';
export {CursorRegularIcon} from './svg/cursor-regular-icon';
export {DeltaArrowDownIcon} from './svg/delta-arrow-down-icon';
export {DeltaArrowUpIcon} from './svg/delta-arrow-up-icon';
export {DesktopIcon} from './svg/desktop-icon';
export {DialpadIcon} from './svg/dialpad-icon';
export {DialpadRegularAiIcon} from './svg/dialpad-regular-ai-icon';
export {DocumentReadyIcon} from './svg/document-ready-icon';
export {DocumentRegularIcon} from './svg/document-regular-icon';
export {DoorClosedIcon} from './svg/door-closed-icon';
export {DoorOpenIcon} from './svg/door-open-icon';
export {DotsArrowRegularLeftIcon} from './svg/dots-arrow-regular-left-icon';
export {DotsArrowRegularRightIcon} from './svg/dots-arrow-regular-right-icon';
export {DoubleColumnIcon} from './svg/double-column-icon';
export {DoubleTickIcon} from './svg/double-tick-icon';
export {DownloadIcon} from './svg/download-icon'; // Use DownloadRegularIcon instead
export {DownloadRegularIcon} from './svg/download-regular-icon';
export {DraftIcon} from './svg/draft-icon';
export {DragHandleIcon} from './svg/drag-handle-icon';
export {DripsRegularIcon} from './svg/drips-regular-icon';
export {EditThickerIcon} from './svg/edit-thicker-icon';
export {EmailIcon} from './svg/email-icon';
export {EmailSeriesIcon} from './svg/email-series-icon';
export {EmptyFolderIcon} from './svg/empty-folder-icon';
export {EmptyInvoicesTableIcon} from './svg/empty-invoices-table';
export {EmptyQuotesTableIcon} from './svg/empty-quotes-table';
export {EngagementIcon} from './svg/engagement-icon';
export {EnvelopeGroupRegularIcon} from './svg/envelope-group-regular-icon';
export {EnvelopeIcon} from './svg/envelope-icon'; // Use EnvelopeRegularIcon instead
export {EnvelopeOpenRegularTemplateIcon} from './svg/envelope-open-regular-template-icon';
export {EnvelopeOpenTextIcon} from './svg/envelope-open-text-icon';
export {EnvelopeRegularIcon} from './svg/envelope-regular-icon';
export {EnvelopeRegularReportIcon} from './svg/envelope-regular-report-icon';
export {EnvelopeRegularUserIcon} from './svg/envelope-regular-user-icon';
export {EnvelopesRegularAiIcon} from './svg/envelopes-regular-ai-icon';
export {EnvelopesRegularIcon} from './svg/envelopes-regular-icon';
export {EraserRegularIcon} from './svg/eraser-regular-icon';
export {ExportRegularIcon} from './svg/export-regular-icon';
export {ExCircleIcon} from './svg/ex-circle-icon';
export {ExpandIcon} from './svg/expand-icon';
export {ExploreIcon} from './svg/explore-icon';
export {ExternalArrowRegularIcon} from './svg/external-arrow-regular-icon';
export {ExternalLinkIcon} from './svg/external-link-icon'; // Use ExternalArrowRegularIcon instead
export {EyeClosedIcon} from './svg/eye-closed-icon';
export {EyeIcon} from './svg/eye-icon'; // Use EyeSolidIcon instead
export {EyeSlashIcon} from './svg/eye-slash-icon';
export {EyeSolidIcon} from './svg/eye-solid-icon';
export {FileAudioIcon} from './svg/file-audio-icon';
export {FileAudioRegularIcon} from './svg/file-audio-regular-icon';
export {FileExcelIcon} from './svg/file-excel-icon';
export {FileIcon} from './svg/file-icon';
export {FileImageIcon} from './svg/file-image-icon';
export {FilePdfIcon} from './svg/file-pdf-icon';
export {FilePowerpointIcon} from './svg/file-powerpoint-icon';
export {FileTextIcon} from './svg/file-text-icon';
export {FileTextRegularIcon} from './svg/file-text-regular-icon';
export {FileUploadIcon} from './svg/file-upload-icon';
export {FileVideoIcon} from './svg/file-video-icon';
export {FileWordIcon} from './svg/file-word-icon';
export {FileZipIcon} from './svg/file-zip-icon';
export {FilterIcon} from './svg/filter-icon';
export {FilterListRegularIcon} from './svg/filter-list-regular-icon';
export {FilterRegularIcon} from './svg/filter-regular-icon';
export {FilterRegularReportIcon} from './svg/filter-regular-report-icon';
export {FireSolidIcon} from './svg/fire-solid-icon';
export {FlagIcon} from './svg/flag-icon';
export {FlagTriangleRegularIcon} from './svg/flag-triangle-regular-icon';
export {FlameIcon} from './svg/flame-icon';
export {FlaskIcon} from './svg/flask-icon';
export {FolderIcon} from './svg/folder-icon';
export {FolderRegularIcon} from './svg/folder-regular-icon';
export {FormRegularCheckIcon} from './svg/form-regular-check-icon';
export {ForwardCircleRegularIcon} from './svg/forward-circle-regular-icon';
export {ForwardRegularIcon} from './svg/forward-regular-icon';
export {FrownyIcon} from './svg/frowny-icon';
export {FxIcon} from './svg/fx-icon';
export {GlobeAmericaRegularIcon} from './svg/globe-america-regular-icon';
export {GlobeCursorRegularIcon} from './svg/globe-cursor-regular-icon';
export {GlobeDomainRegularIcon} from './svg/globe-domain-regular-icon';
export {GlobeRegularIcon} from './svg/globe-regular-icon';
export {GlobeRegularSearchIcon} from './svg/globe-regular-search-icon';
export {GlossaryBookmarkIcon} from './svg/glossary-bookmark-icon';
export {GlossaryIcon} from './svg/glossary-icon';
export {GmailRegularIcon} from './svg/gmail-regular-icon';
export {GoalActivityLoggedIcon} from './svg/goal-activity-logged-icon';
export {GoalAudienceIcon} from './svg/goal-audience-icon';
export {GoalClickIcon} from './svg/goal-click-icon';
export {GoalEmailIcon} from './svg/goal-email-icon';
export {GoalLeadClosedIcon} from './svg/goal-lead-closed-icon';
export {GoalLeadCreatedIcon} from './svg/goal-lead-created-icon';
export {GoalLeadFieldsIcon} from './svg/goal-lead-fields-icon';
export {GoalLeadInfoIcon} from './svg/goal-lead-info-icon';
export {GoalLeadStageIcon} from './svg/goal-lead-stage-icon';
export {GoalLeadValueIcon} from './svg/goal-lead-value-icon';
export {GoalQuoteIcon} from './svg/goal-quote-icon';
export {GoalTagIcon} from './svg/goal-tag-icon';
export {GoogleCalendarIcon} from './svg/google-calendar-icon';
export {GoogleCalendarRegularIcon} from './svg/google-calendar-regular-icon';
export {GoogleCalendarToNutshellIcon} from './svg/google-calendar-to-nutshell-icon';
export {GoogleMeetIcon} from './svg/google-meet-icon';
export {GoogleMeetRegularIcon} from './svg/google-meet-regular-icon';
export {GoogleRegularAiIcon} from './svg/google-regular-ai-icon';
export {GoogleRegularIcon} from './svg/google-regular-icon';
export {H1Icon} from './svg/h1-icon';
export {H2Icon} from './svg/h2-icon';
export {HalfAndHalfIcon} from './svg/half-and-half-icon';
export {HashIcon} from './svg/hash-icon';
export {HashtagRegularIcon} from './svg/hashtag-regular-icon';
export {HeadsetRegularIcon} from './svg/headset-regular-icon';
export {HeartIcon} from './svg/heart-icon';
export {HierarchyRegularIcon} from './svg/hierarchy-regular-icon';
export {HomeIcon} from './svg/home-icon';
export {HouseRegularIcon} from './svg/house-regular-icon';
export {HorizontalChartIcon} from './svg/horizontal-chart-icon';
export {HourglassEndIcon} from './svg/hourglass-end-icon';
export {HourglassHalfIcon} from './svg/hourglass-half-icon';
export {HourglassRegularIcon} from './svg/hourglass-regular-icon';
export {HourglassStartIcon} from './svg/hourglass-start-icon';
export {HtmlBoldIcon} from './svg/html-bold-icon';
export {HtmlImageIcon} from './svg/html-image-icon';
export {HtmlItalicIcon} from './svg/html-italic-icon';
export {HtmlLinkIcon} from './svg/html-link-icon';
export {HtmlListIcon} from './svg/html-list-icon';
export {HtmlUnderlineIcon} from './svg/html-underline-icon';
export {ImportIcon} from './svg/icon-import';
export {ImportRegularIcon} from './svg/import-regular-icon';
export {InboundArrowIcon} from './svg/inbound-arrow-icon';
export {InboundCallIcon} from './svg/inbound-call-icon';
export {IndustryIcon} from './svg/industry-icon';
export {IndustryRegularIcon} from './svg/industry-regular-icon';
export {InfoCircleRegularIcon} from './svg/info-circle-regular-icon';
export {InfoIcon} from './svg/info-icon';
export {InfoSquareRegularIcon} from './svg/info-square-regular-icon';
export {IntegrationOutlineRegularIcon} from './svg/integration-outline-regular-icon';
export {IntercomRegularIcon} from './svg/intercom-regular-icon';
export {InstagramIcon} from './svg/instagram-icon';
export {InvoiceCircleSolidIcon} from './svg/invoice-circle-solid-icon';
export {InvoiceIcon} from './svg/invoice-icon';
export {InvoiceRegularDiagonalIcon} from './svg/invoice-regular-diagonal-icon';
export {InvoiceRegularIcon} from './svg/invoice-regular-icon';
export {KebabRegularIcon} from './svg/kebab-regular-icon';
export {KeyboardRegularIcon} from './svg/keyboard-regular-icon';
export {KixieIcon} from './svg/kixie-icon';
export {KixieRegularAiIcon} from './svg/kixie-regular-ai-icon';
export {LayoutRegularIcon} from './svg/layout-regular-icon';
export {LeadCancelledIcon} from './svg/lead-cancelled-icon'; // Use CancelCircleRegularIcon instead
export {LeadChevronRegularIcon} from './svg/lead-chevron-regular-icon';
export {LeadIcon} from './svg/lead-icon';
export {LeadIconChevron} from './svg/lead-icon-chevron';
export {LeadLostIcon} from './svg/lead-lost-icon';
export {LeadPendingIcon} from './svg/lead-pending-icon';
export {LeadRegularPlusIcon} from './svg/lead-regular-plus-icon';
export {LeadResearcherIcon} from './svg/lead-researcher-icon';
export {LeadsCircleIcon} from './svg/leads-circle-icon';
export {LeadSearchRegularAiIcon} from './svg/lead-search-regular-ai-icon';
export {LightbulbBrightIcon} from './svg/lightbulb-bright-icon';
export {LightbulbDimIcon} from './svg/lightbulb-dim-icon';
export {LightbulbRegularIcon} from './svg/lightbulb-regular-icon';
export {LinesLongRegularIcon} from './svg/lines-long-regular-icon';
export {LineVerticalIcon} from './svg/line-vertical-icon';
export {LinkClickIcon} from './svg/link-click-icon';
export {LinkedInIcon} from './svg/linked-in-icon';
export {ListIcon} from './svg/list-icon';
export {ListRegularIcon} from './svg/list-regular-icon';
export {LoadingIcon} from './svg/loading-icon';
export {LocationPinCircleSolidIcon} from './svg/location-pin-circle-solid-icon';
export {LocationPinIcon} from './svg/location-pin-icon';
export {LocationPinRegularIcon} from './svg/location-pin-regular-icon';
export {LocationPinSolidIcon} from './svg/location-pin-solid-icon';
export {LockedIcon} from './svg/locked-icon';
export {LockRegularIcon} from './svg/lock-regular-icon';
export {LongTextIcon} from './svg/long-text-icon';
export {MagicIcon} from './svg/magic-icon';
export {MagnifyingGlassChartIcon} from './svg/magnifying-glass-chart-icon';
export {MagnifyingGlassDollarIcon} from './svg/magnifying-glass-dollar-icon';
export {MailchimpIcon} from './svg/mailchimp-icon';
export {MailerRegularAiIcon} from './svg/mailer-regular-ai-icon';
export {MapPinIcon} from './svg/map-pin-icon';
export {McpLogoIcon} from './svg/mcp-logo-icon';
export {McpRegularAiIcon} from './svg/mcp-regular-ai-icon';
export {MedalRegularIcon} from './svg/medal-regular-icon';
export {MeetingIcon} from './svg/meeting-icon';
export {MegaphoneRegularIcon} from './svg/megaphone-regular-icon';
export {MessageIcon} from './svg/message-icon';
export {MessageIconSolid} from './svg/message-icon-solid';
export {MessagesDollarIcon} from './svg/messages-dollar-icon';
export {MessagesIcon} from './svg/messages-icon';
export {MessageSquareQuoteIcon} from './svg/message-square-quote-icon';
export {MessengerIcon} from './svg/messenger-icon';
export {MicrophoneIcon} from './svg/microphone-icon';
export {MicrophoneRegularIcon} from './svg/microphone-regular-icon';
export {Microsoft365RegularIcon} from './svg/microsoft-365-regular-icon';
export {MicrosoftOutlookRegularIcon} from './svg/microsoft-outlook-regular-icon';
export {MicrosoftTeamsIcon} from './svg/microsoft-teams-icon';
export {MicrosoftTeamsRegularAiIcon} from './svg/microsoft-teams-regular-ai-icon';
export {MicrosoftTeamsRegularIcon} from './svg/microsoft-teams-regular-icon';
export {MinusIcon} from './svg/minus-icon';
export {MobilePhoneRegularIcon} from './svg/mobile-phone-regular-icon';
export {MultiplePipelineIcon} from './svg/multiple-pipeline-icon';
export {NewsletterIcon} from './svg/newsletter-icon';
export {NextStepIcon} from './svg/next-step-icon';
export {NoteIcon} from './svg/note-icon'; // Use NoteRegularIcon instead
export {NotePencilRegularIcon} from './svg/note-pencil-regular-icon';
export {NoteRegularAiIcon} from './svg/note-regular-ai-icon';
export {NoteRegularIcon} from './svg/note-regular-icon';
export {NotetakerIcon} from './svg/notetaker-icon';
export {NotSyncedIcon} from './svg/not-synced-icon';
export {NutshellLogoMarkIcon} from './svg/nutshell-logo-mark-icon';
export {NutshellToCalendarIcon} from './svg/nutshell-to-calendar-icon';
export {NutshellToGoogleCalendarIcon} from './svg/nutshell-to-google-calendar-icon';
export {NutshelltoOfficeRegularIcon} from './svg/nutshellto-office-regular-icon';
export {OfficetoNutshellRegularIcon} from './svg/officeto-nutshell-regular-icon';
export {OlarkRegularIcon} from './svg/olark-regular-icon';
export {OpenAIOutlineAIIcon} from './svg/openai-outline-ai-icon';
export {OpenIcon} from './svg/open-icon';
export {OutboundArrowIcon} from './svg/outbound-arrow-icon';
export {OutboundCallIcon} from './svg/outbound-call-icon';
export {OutlookCalendarIcon} from './svg/outlook-calendar-icon';
export {OutreachIcon} from './svg/outreach-icon';
export {OverviewRegularAiIcon} from './svg/overview-regular-ai-icon';
export {PaletteRegularIcon} from './svg/palette-regular-icon';
export {PandadocIcon} from './svg/pandadoc-icon';
export {PaperClipRegularDiagonalIcon} from './svg/paper-clip-regular-diagonal-icon';
export {ParagraphRegularIcon} from './svg/paragraph-regular-icon';
export {ParentCompanyIcon} from './svg/parent-company-icon';
export {PauseCircleIcon} from './svg/pause-circle-icon';
export {PencilRegularIcon} from './svg/pencil-regular-icon';
export {PencilRegularRenameIcon} from './svg/pencil-regular-rename-icon';
export {PencilToPaperRegularIcon} from './svg/pencil-to-paper-regular-icon';
export {PenRulerRegularIcon} from './svg/pen-ruler-regular-icon';
export {PeopleRegularIcon} from './svg/people-regular-icon';
export {PeopleRoofRegularIcon} from './svg/people-roof-regular-icon';
export {PersonCheckIcon} from './svg/person-check-icon';
export {PersonCircleRegularIcon} from './svg/person-circle-regular-icon';
export {PersonExitDoorRegularIcon} from './svg/person-exit-door-regular-icon';
export {PersonRegularIcon} from './svg/person-regular-icon';
export {PersonSearchRegularAiIcon} from './svg/person-search-regular-ai-icon';
export {PersonSearchRegularIcon} from './svg/person-search-regular-icon';
export {PersonSquareRegularIcon} from './svg/person-square-regular-icon';
export {PersonWarningIcon} from './svg/person-warning-icon';
export {PhoneCallIcon} from './svg/phone-call-icon'; // Use PhoneRegularIcon instead
export {PhoneRegularAiIcon} from './svg/phone-regular-ai-icon';
export {PhoneRegularDiagonalInIcon} from './svg/phone-regular-diagonal-in-icon';
export {PhoneRegularDiagonalOutIcon} from './svg/phone-regular-diagonal-out-icon';
export {PhoneRegularIcon} from './svg/phone-regular-icon';
export {PiechartRegularAiIcon} from './svg/piechart-regular-ai-icon';
export {PinIcon} from './svg/pin-icon';
export {PipelineRegularAiIcon} from './svg/pipeline-regular-ai-icon';
export {PipelineRegularIcon} from './svg/pipeline-regular-icon';
export {PlaneRegularDiagonalIcon} from './svg/plane-regular-diagonal-icon';
export {PlantBigFilledIcon} from './svg/plant-big-filled-icon';
export {PlantSmallFilledIcon} from './svg/plant-small-filled-icon';
export {PlayButtonIcon} from './svg/play-button-icon';
export {PlayCircleRegularIcon} from './svg/play-circle-regular-icon';
export {PlayRoundedIcon} from './svg/play-rounded-icon';
export {PlusRegularIcon} from './svg/plus-regular-icon';
export {PlusThinIcon} from './svg/plus-thin-icon';
export {ProBadgeIcon} from './svg/pro-badge';
export {ProductIcon} from './svg/product-icon'; // Use BoxRegularIcon instead
export {ProductImportIcon} from './svg/product-import-icon';
export {ProspectorIcon} from './svg/prospector-icon';
export {PuzzleIcon} from './svg/puzzle-icon';
export {QRCodeIcon} from './svg/qr-code-icon';
export {QuickbooksRegularIcon} from './svg/quickbooks-regular-icon';
export {QuotaImportIcon} from './svg/quota-import-icon';
export {QuotaReachedIcon} from './svg/quota-reached-icon';
export {QuoteIcon} from './svg/quote-icon';
export {QuoteRegularIcon} from './svg/quote-regular-icon';
export {RadioIcon} from './svg/radio-icon';
export {RecurringRegularIcon} from './svg/recurring-regular-icon';
export {ReplyAllIcon} from './svg/reply-all-icon';
export {ReplyArrowRegularAiIcon} from './svg/reply-arrow-regular-ai-icon';
export {ReplyClockIcon} from './svg/reply-clock-icon';
export {ReplyIcon} from './svg/reply-icon';
export {ReportsIcon} from './svg/reports-icon';
export {RetiringIcon} from './svg/retiring-icon';
export {RetryRegularIcon} from './svg/retry-regular-icon';
export {ReturnIcon} from './svg/return-icon';
export {RevenueIcon} from './svg/revenue-icon';
export {RevenueRegularIcon} from './svg/revenue-regular-icon';
export {RingcentralIcon} from './svg/ringcentral-icon';
export {RingcentralRegularAiIcon} from './svg/ringcentral-regular-ai-icon';
export {RobotIcon} from './svg/robot-icon';
export {SalesBubbleRegularAiIcon} from './svg/sales-bubble-regular-ai-icon';
export {SalesProcessRegularIcon} from './svg/sales-process-regular-icon';
export {SavingIcon} from './svg/saving-icon';
export {SchedulerIcon} from './svg/scheduler-icon';
export {SearchBarsRegularAiIcon} from './svg/search-bars-regular-ai-icon';
export {SearchDollarRegularAiIcon} from './svg/search-dollar-regular-ai-icon';
export {SearchRegularIcon} from './svg/search-regular-icon';
export {SelectMultiIcon} from './svg/select-multi-icon';
export {SendIcon} from './svg/send-icon';
export {SentEmailIcon} from './svg/sent-email-icon';
export {ShareRegularIcon} from './svg/share-regular-icon';
export {ShoppingCartRegularIcon} from './svg/shopping-cart-regular-icon';
export {ShortTextIcon} from './svg/short-text-icon';
export {SidebarIconAccountsIcon} from './svg/sidebar-icon-accounts';
export {SidebarIconContactsIcon} from './svg/sidebar-icon-contacts';
export {SidebarIconDashboardIcon} from './svg/sidebar-icon-dashboard';
export {SidebarIconHelpIcon} from './svg/sidebar-icon-help';
export {SidebarIconLogoutIcon} from './svg/sidebar-icon-logout';
export {SidebarIconNotificationsIcon} from './svg/sidebar-icon-notifications';
export {SidebarIconReportsIcon} from './svg/sidebar-icon-reports';
export {SidebarIconReportsIconOld} from './svg/sidebar-icon-reports-old';
export {SidebarIconSearchIcon} from './svg/sidebar-icon-search';
export {SidebarIconSetupIcon} from './svg/sidebar-icon-setup';
export {SingleColumnIcon} from './svg/single-column-icon';
export {SiteGlobeIcon} from './svg/site-globe-icon';
export {SlackIcon} from './svg/slack-icon';
export {SlackRegularIcon} from './svg/slack-regular-icon';
export {SmsIcon} from './svg/sms-icon';
export {SolidClockIcon} from './svg/solid-clock-icon';
export {SolidInfoIcon} from './svg/solid-info-icon';
export {SortDownIcon} from './svg/sort-down-icon';
export {SortIcon} from './svg/sort-icon';
export {SourceIcon} from './svg/source-icon';
export {SourceRegularIcon} from './svg/source-regular-icon';
export {SquareArrowRightRegularIcon} from './svg/square-arrow-right-regular-icon';
export {SquareArrowUpRightIcon} from './svg/square-arrow-up-right-icon';
export {SquareCheckRegularIcon} from './svg/square-check-regular-icon';
export {SquareRegularIcon} from './svg/square-regular-icon';
export {SquircleZoomRegularIcon} from './svg/squircle-zoom-regular-icon';
export {StageIcon} from './svg/stage-icon';
export {StarRegularIcon} from './svg/star-regular-icon';
export {StarRegularReportIcon} from './svg/star-regular-report-icon';
export {StopCircleIcon} from './svg/stop-circle-icon';
export {StopIcon} from './svg/stop-icon';
export {SuccessMessageIcon} from './svg/success-message-icon';
export {SyncRegularIcon} from './svg/sync-regular-icon';
export {TableRegularPencilIcon} from './svg/table-regular-pencil-icon';
export {TabletIcon} from './svg/tablet-icon';
export {TagIcon} from './svg/tag-icon';
export {TagRegularDiagonalIcon} from './svg/tag-regular-diagonal-icon';
export {TagRegularDiagonalReportIcon} from './svg/tag-regular-diagonal-report-icon';
export {TagsRegularDiagonalReportIcon} from './svg/tags-regular-diagonal-report-icon';
export {TargetArrowRegularIcon} from './svg/target-arrow-regular-icon';
export {TargetRegularIcon} from './svg/target-regular-icon';
export {TaskIcon} from './svg/task-icon';
export {TaskRegularAiIcon} from './svg/task-regular-ai-icon';
export {TeamIcon} from './svg/team-icon';
export {TemplateIcon} from './svg/template-icon';
export {TerritoryIcon} from './svg/territory-icon';
export {TextBlockIcon} from './svg/text-block-icon';
export {TextRegularAiIcon} from './svg/text-regular-ai-icon';
export {ThumbsDownIcon} from './svg/thumbs-down-icon';
export {ThumbsDownRegularIcon} from './svg/thumbs-down-regular-icon';
export {ThumbsUpIcon} from './svg/thumbs-up-icon';
export {ThumbsUpRegularIcon} from './svg/thumbs-up-regular-icon';
export {TickCircleIcon} from './svg/tick-circle-icon';
export {TickCircleOutlineIcon} from './svg/tick-circle-outline-icon'; // Use CheckCircleRegularIcon instead
export {TicketIcon} from './svg/ticket-icon';
export {TimelineArrowRegularIcon} from './svg/timeline-arrow-regular-icon';
export {TimelineRegularAiIcon} from './svg/timeline-regular-ai-icon';
export {TimelineRegularIcon} from './svg/timeline-regular-icon';
export {TodoEmptyStateIcon} from './svg/todo-empty-state-icon';
export {TodoErrorStateIcon} from './svg/todo-error-state-icon';
export {TranscribeIcon} from './svg/transcribe-icon';
export {TrashEmptyIcon} from './svg/trash-empty-icon';
export {TrashIcon} from './svg/trash-icon'; // Use TrashRegularIcon instead
export {TrashRegularIcon} from './svg/trash-regular-icon';
export {TrophyIcon} from './svg/trophy-icon';
export {TVRetroIcon} from './svg/tv-retro-icon';
export {UndoRegularIcon} from './svg/undo-regular-icon';
export {UnlockIcon} from './svg/unlock-icon';
export {UnloggedIcon} from './svg/unlogged-icon';
export {UnpinIcon} from './svg/unpin-icon';
export {UpgradeArrowIcon} from './svg/upgrade-arrow-icon';
export {UpgradeArrowIconNewNav} from './svg/upgrade-arrow-icon-new-nav';
export {UserDigestRegularAiIcon} from './svg/user-digest-regular-ai-icon';
export {UserGroupIcon} from './svg/user-group-icon';
export {UserIcon} from './svg/user-icon';
export {VerticalConnectorIcon} from './svg/vertical-connector-icon';
export {VideoCameraRegularIcon} from './svg/video-camera-regular-icon';
export {VirtualMeetingIcon} from './svg/virtual-meeting-icon';
export {VisitorIqIcon} from './svg/visitor-iq-icon';
export {VoicemailIcon} from './svg/voicemail-icon';
export {WarningRegularIcon} from './svg/warning-regular-icon';
export {WarningSolidIcon} from './svg/warning-solid-icon';
export {WebFormIcon} from './svg/web-form-icon';
export {WhatsAppIcon} from './svg/whatsapp-icon';
export {WrenchRegularIcon} from './svg/wrench-regular-icon';
export {XSocialIcon} from './svg/x-social-icon';
export {ZendeskRegularIcon} from './svg/zendesk-regular-icon';
export {ZoomIcon} from './svg/zoom-icon';
export {ZoomRegularAiIcon} from './svg/zoom-regular-ai-icon';
export {ZoomRegularIcon} from './svg/zoom-regular-icon';
export {ZoomTextIcon} from './svg/zoom-text-icon';

// Font Awesome Icons
/**
 * @deprecated This is a legacy icon
 */
export const AsteriskIcon = faIconCreator('asterisk');
/**
 * @deprecated This is a legacy icon
 */
export const CaretDown = faIconCreator('caret-down');
/**
 * @deprecated This is a legacy icon
 */
export const CaretRight = faIconCreator('caret-right');
/**
 * @deprecated This is a legacy icon
 */
export const CaretUp = faIconCreator('caret-up');
/**
 * @deprecated This is a legacy icon
 */
export const CheckIcon = faIconCreator('check');
/**
 * @deprecated This is a legacy icon
 */
export const ChevronDownIcon = faIconCreator('chevron-down');
/**
 * @deprecated This is a legacy icon
 */
export const ChevronLeftIcon = faIconCreator('chevron-left');
/**
 * @deprecated This is a legacy icon
 */
export const ChevronRightIcon = faIconCreator('chevron-right');
/**
 * @deprecated This is a legacy icon
 */
export const ChevronUpIcon = faIconCreator('chevron-up');
/**
 * @deprecated This is a legacy icon
 */
export const ClockIcon = faIconCreator('clock-o');
/**
 * @deprecated This is a legacy icon
 */
export const CloudDownloadIcon = faIconCreator('cloud-download');
/**
 * @deprecated This is a legacy icon
 */
export const CloudUploadIcon = faIconCreator('cloud-upload');
/**
 * @deprecated This is a legacy icon
 */
export const CreditCardIcon = faIconCreator('credit-card');
/**
 * @deprecated This is a legacy icon
 */
export const DescriptionIcon = faIconCreator('align-left');
/**
 * @deprecated This is a legacy icon
 */
export const DollarSymbolIcon = faIconCreator('usd');
/**
 * @deprecated This is a legacy icon
 */
export const EditIcon = faIconCreator('edit');
/**
 * @deprecated This is a legacy icon
 */
export const ErrorCircleIcon = faIconCreator('exclamation-circle');
/**
 * @deprecated This is a legacy icon
 */
export const ErrorTriangleIcon = faIconCreator('exclamation-triangle');
/**
 * @deprecated This is a legacy icon
 */
export const GlobeIcon = faIconCreator('globe');
/**
 * @deprecated This is a legacy icon
 */
export const HashtagIcon = faIconCreator('hashtag');
/**
 * @deprecated This is a legacy icon
 */
export const LockIcon = faIconCreator('lock');
/**
 * @deprecated This is a legacy icon
 */
export const MicrophoneSlashIcon = faIconCreator('microphone-slash');
/**
 * @deprecated This is a legacy icon
 */
export const MinimizeIcon = faIconCreator('window-minimize');
/**
 * @deprecated This is a legacy icon
 */
export const MinusCircleIcon = faIconCreator('minus-circle');
/**
 * @deprecated This is a legacy icon
 */
export const PaperPlane = faIconCreator('paper-plane');
/**
 * @deprecated This is a legacy icon
 */
export const Pencil = faIconCreator('pencil'); // use PencilRegularIcon instead
/**
 * @deprecated This is a legacy icon
 */
export const PhoneIcon = faIconCreator('phone'); // Use PhoneRegularIcon instead
/**
 * @deprecated This is a legacy icon
 */
export const PlusIcon = faIconCreator('plus');
/**
 * @deprecated This is a legacy icon
 */
export const RepeatIcon = faIconCreator('repeat');
/**
 * @deprecated This is a legacy icon
 */
export const RocketIcon = faIconCreator('rocket');
/**
 * @deprecated This is a legacy icon
 */
export const SearchIcon = faIconCreator('search');
/**
 * @deprecated This is a legacy icon
 */
export const ShareIcon = faIconCreator('share');
/**
 * @deprecated This is a legacy icon
 */
export const SpinnerIcon = faIconCreator('spinner fa-spin');
/**
 * @deprecated This is a legacy icon
 */
export const StarIcon = faIconCreator('star');
/**
 * @deprecated This is a legacy icon
 */
export const TimesCircleIcon = faIconCreator('times-circle');
/**
 * @deprecated This is a legacy icon
 */
export const TimesIcon = faIconCreator('times');
/**
 * @deprecated This is a legacy icon
 */
export const WandIcon = faIconCreator('magic');
